import React from 'react';

function Legend() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4">
      <div className="bg-slate-50 rounded-lg border border-slate-200 p-6">
        <h3 className="font-semibold text-gray-900 mb-4 text-lg">Legend</h3>

        {/* Status Indicators */}
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-2 uppercase">Status Indicators</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="legend-item">
              <span className="text-xl">✓</span>
              <span>Active - Currently enforceable</span>
            </div>
            <div className="legend-item">
              <span className="text-xl">⚖</span>
              <span>Challenged - Legal challenge pending</span>
            </div>
            <div className="legend-item">
              <span className="text-xl">◷</span>
              <span>Pending - Not yet effective</span>
            </div>
            <div className="legend-item">
              <span className="text-xl">✕</span>
              <span>Blocked - Enjoined/unconstitutional</span>
            </div>
          </div>
        </div>

        {/* Category Badges */}
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-2 uppercase">Category Types</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium whitespace-nowrap">
                Federal
              </span>
              <span className="text-sm text-gray-600">US federal laws (Take It Down Act, COPPA, KOSA)</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium whitespace-nowrap">
                Consumer Privacy
              </span>
              <span className="text-sm text-gray-600">State privacy laws with children's provisions</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium whitespace-nowrap">
                Social Media
              </span>
              <span className="text-sm text-gray-600">Platform-specific age and consent requirements</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium whitespace-nowrap">
                AADC
              </span>
              <span className="text-sm text-gray-600">Age-Appropriate Design Code laws (5 states)</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium whitespace-nowrap">
                App Store
              </span>
              <span className="text-sm text-gray-600">App store age verification and parental consent</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium whitespace-nowrap">
                Age Verification
              </span>
              <span className="text-sm text-gray-600">Age verification for adult/harmful content (22+ states)</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium whitespace-nowrap">
                AI Chatbot
              </span>
              <span className="text-sm text-gray-600">New 2026: AI companion chatbot safety for minors</span>
            </div>
          </div>
        </div>

        {/* Section Headers */}
        <div>
          <h4 className="text-sm font-semibold text-gray-700 mb-2 uppercase">Jurisdiction Sections</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-3">
              <div className="bg-gradient-to-r from-blue-600 to-blue-400 text-white px-4 py-2 rounded-lg font-semibold text-sm">
                <i className="fas fa-flag-usa mr-2"></i>
                United States Laws
              </div>
              <span className="text-sm text-gray-600">US federal &amp; state laws (78 laws)</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="bg-gradient-to-r from-green-600 to-green-400 text-white px-4 py-2 rounded-lg font-semibold text-sm">
                <i className="fas fa-globe-americas mr-2"></i>
                International Laws
              </div>
              <span className="text-sm text-gray-600">18 jurisdictions tracked (23 laws)</span>
            </div>
          </div>
        </div>

        {/* Regional Indicators */}
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex items-center gap-3 text-sm text-gray-600">
            <i className="fas fa-info-circle text-purple-600"></i>
            <span><strong>Regional Tags:</strong> International laws show their geographic region (e.g., Europe, Asia-Pacific) next to the country name</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Legend;
